import { render, staticRenderFns } from "./SportFederationDialog.vue?vue&type=template&id=fc6d577a&scoped=true"
import script from "./SportFederationDialog.vue?vue&type=script&lang=js"
export * from "./SportFederationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6d577a",
  null
  
)

export default component.exports